import * as React from 'react';
import {ReactNode} from 'react';
import {ICheatPluginView} from './CheatModuleInterfaces';

export class CheatPluginView<C = {}, P = {}, S = {}> extends React.Component<P, S> implements ICheatPluginView<C> {

    readonly controller!: C;

    constructor(props: P & Readonly<{ children?: ReactNode; controller: C;}>) {
        super(props);

        this.controller = props.controller;
    }
}
